import { render, staticRenderFns } from "./DialogCreateSubtask.vue?vue&type=template&id=ddd0cd74&scoped=true"
import script from "./DialogCreateSubtask.vue?vue&type=script&lang=js"
export * from "./DialogCreateSubtask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd0cd74",
  null
  
)

export default component.exports